import noop from 'lodash/noop';
import { useEffect } from 'react';

// #region Types
type WindowEventProps = {
  eventType: keyof WindowEventMap;
  listenTo?: 'window';
};

type DocumentEventProps = {
  eventType: keyof DocumentEventMap;
  listenTo: 'document';
};

type OrientationEventProps = {
  eventType: keyof ScreenOrientationEventMap;
  listenTo: 'orientation';
};

type ElementEventProps = {
  eventType: keyof HTMLElementEventMap;
  listenTo: HTMLElement | null;
};

export type UseEventListenerProps = (
  | WindowEventProps
  | DocumentEventProps
  | OrientationEventProps
  | ElementEventProps
) & {
  enabled?: boolean;
  listener: EventListenerOrEventListenerObject;
};
// #endregion

/**
 * Event listener creation & destruction helper
 *
 * @param param
 */
export default function useEventListener({
  enabled = true,
  eventType,
  listener,
  listenTo = 'window',
}: UseEventListenerProps) {
  // #region Effects
  useEffect(() => {
    if (!enabled) return noop;

    const listen =
      typeof listenTo === 'string'
        ? {
            document,
            orientation: window.screen.orientation,
            window,
          }[listenTo]
        : listenTo;

    listen?.addEventListener(eventType, listener);

    return () => {
      listen?.removeEventListener(eventType, listener);
    };
  }, [enabled, listenTo, listener, eventType]);
  // #endregion
}
